import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "kn-page" }
const _hoisted_2 = { class: "kn-page-content p-grid p-m-0" }
const _hoisted_3 = { class: "p-col" }
const _hoisted_4 = { class: "table-header" }
const _hoisted_5 = { class: "p-input-icon-left" }
const _hoisted_6 = /*#__PURE__*/_createVNode("i", { class: "pi pi-search" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KnFabButton = _resolveComponent("KnFabButton")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Column = _resolveComponent("Column")
  const _component_Button = _resolveComponent("Button")
  const _component_DataTable = _resolveComponent("DataTable")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary" }, {
      start: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('managers.scorecards.title')), 1)
      ]),
      end: _withCtx(() => [
        _createVNode(_component_KnFabButton, {
          icon: "fas fa-plus",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openScorecardDetail()))
        })
      ]),
      _: 1
    }),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_DataTable, {
          value: _ctx.scorecards,
          paginator: _ctx.scorecards.length > 20,
          rows: 20,
          class: "p-datatable-sm kn-table",
          dataKey: "id",
          filters: _ctx.filters,
          "onUpdate:filters": _cache[3] || (_cache[3] = ($event: any) => (_ctx.filters = $event)),
          globalFilterFields: _ctx.scorecardsDescriptor.globalFilterFields,
          responsiveLayout: "stack",
          breakpoint: "960px",
          onRowClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openScorecardDetail($event.data)))
        }, {
          header: _withCtx(() => [
            _createVNode("div", _hoisted_4, [
              _createVNode("span", _hoisted_5, [
                _hoisted_6,
                _createVNode(_component_InputText, {
                  class: "kn-material-input",
                  modelValue: _ctx.filters['global'].value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.filters['global'].value = $event)),
                  placeholder: _ctx.$t('common.search')
                }, null, 8, ["modelValue", "placeholder"])
              ])
            ])
          ]),
          empty: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_Column, {
              class: "kn-truncated",
              field: "name",
              header: _ctx.$t('common.name'),
              sortable: true
            }, null, 8, ["header"]),
            _createVNode(_component_Column, {
              class: "kn-truncated",
              field: "creationDate",
              header: _ctx.$t('common.creationDate'),
              sortable: true
            }, {
              body: _withCtx((slotProps) => [
                _createVNode("span", null, _toDisplayString(_ctx.getFormattedDate(slotProps.data.creationDate)), 1)
              ]),
              _: 1
            }, 8, ["header"]),
            _createVNode(_component_Column, {
              class: "kn-truncated",
              field: "author",
              header: _ctx.$t('common.author'),
              sortable: true
            }, null, 8, ["header"]),
            _createVNode(_component_Column, {
              style: _ctx.scorecardsDescriptor.iconColumnStyle
            }, {
              body: _withCtx((slotProps) => [
                _createVNode(_component_Button, {
                  icon: "pi pi-trash",
                  class: "p-button-link",
                  onClick: ($event: any) => (_ctx.deleteScorecardConfirm(slotProps.data))
                }, null, 8, ["onClick"])
              ]),
              _: 1
            }, 8, ["style"])
          ]),
          _: 1
        }, 8, ["value", "paginator", "filters", "globalFilterFields"])
      ])
    ])
  ]))
}